module.exports = __webpack_public_path__ + "static/media/Таран А.Е..72f9147d.pdf";